import { z } from 'zod';
import { RiskLevel } from './risk.js';
export const DependencyNode = z.object({
    name: z.string(),
    version: z.string(),
    isDirect: z.boolean(),
    dependents: z.array(z.string()),
    isDevDependency: z.boolean(),
    hasKnownVulnerabilities: z.boolean().optional(),
    latestVersion: z.string().optional(),
});
export const DependencyEdge = z.object({
    from: z.string(),
    to: z.string(),
    type: z.enum(['runtime', 'dev', 'peer', 'optional']),
});
export const DependencyGraph = z.object({
    nodes: z.array(DependencyNode),
    edges: z.array(DependencyEdge),
    cycles: z.array(z.array(z.string())),
    totalCount: z.number().int(),
});
export const BreakingChangeType = z.enum([
    'API_SIGNATURE', 'TYPE_CHANGE', 'REMOVAL', 'BEHAVIORAL',
    'DEPENDENCY_UPGRADE', 'ENUM_CHANGE', 'SCHEMA_CHANGE',
]);
export const BreakingChangeReport = z.object({
    file: z.string(),
    changeType: BreakingChangeType,
    severity: RiskLevel,
    confidence: z.number().min(0).max(1),
    description: z.string(),
    affectedDependents: z.array(z.string()),
    suggestedFix: z.string().optional(),
});
export const ComplianceCategory = z.enum([
    'STRUCTURE', 'DEPENDENCY', 'NAMING', 'PATTERN', 'SECURITY', 'PERFORMANCE',
]);
export const ComplianceViolation = z.object({
    file: z.string(),
    line: z.number().optional(),
    message: z.string(),
    severity: z.enum(['error', 'warning', 'info']),
});
export const ArchitectureComplianceResult = z.object({
    rule: z.string(),
    category: ComplianceCategory,
    passed: z.boolean(),
    violations: z.array(ComplianceViolation),
});
//# sourceMappingURL=github.js.map